import { Outlet, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import IncidencesTableWithFilters from 'modules/bookkeepers/components/IncidencesTableWithFilters'
import { PolicyPeriodsProvider } from 'modules/payroll_bundle/lib/policyPeriodsContext'
// eslint-disable-next-line factorial/no-allowed-mobx-collections
import policyPeriodCollection from 'modules/payroll_bundle/store/collections/policyPeriods'

const IncidencesPage = () => {
  const { id } = useParams()
  const selectedIncidenceId = id ? +id : null

  return (
    <PolicyPeriodsProvider policyPeriodCollection={policyPeriodCollection} isBookkeeper>
      <Box width="full" background="grey000White" alignItems="flexStart" gap="s24" padding="s24">
        <IncidencesTableWithFilters
          incidenceDetail={<Outlet />}
          selectedIncidenceId={selectedIncidenceId}
        />
      </Box>
    </PolicyPeriodsProvider>
  )
}

export default IncidencesPage
